import { Help } from './Help';

export default {
  name: 'help',
  title: 'Reflex Hjälp',
  navbar: {
    component: Help
  }
};
